import {
    INSIGHT_AREA_ADD_MAPPING,
    INSIGHT_AREA_ADD_NEW,
    INSIGHT_AREA_ADD_PLACEHOLDER_IMAGES,
    INSIGHT_AREA_APPLY_ADD_OWNERS_VIEWERS,
    INSIGHT_AREA_APPLY_FILTER_CRITERIA,
    INSIGHT_AREA_APPLY_MODEL_UPDATE,
    INSIGHT_AREA_CANCEL_ADD_OWNERS_VIEWERS,
    INSIGHT_AREA_CANCEL_MODEL_UPDATE,
    INSIGHT_AREA_CLEAR_FILTER_CRITERIA,
    INSIGHT_AREA_FINISH_SAVING,
    INSIGHT_AREA_FINISH_SAVING_ERROR,
    INSIGHT_AREA_ITEM_REQUEST,
    INSIGHT_AREA_ITEM_RESPONSE,
    INSIGHT_AREA_ITEM_SYNC_REQUEST,
    INSIGHT_AREA_ITEM_SYNC_RESPONSE,
    INSIGHT_AREA_ITEM_SAVE_RESPONSE,
    INSIGHT_AREA_LIST_PAGE_REQUEST,
    INSIGHT_AREA_LIST_RESPONSE,
    INSIGHT_AREA_LIST_SEARCH_REQUEST,
    INSIGHT_AREA_MAPPING_DELETE_PREVIEW_REQUEST,
    INSIGHT_AREA_MAPPING_PREVIEW_ERROR_RESPONSE,
    INSIGHT_AREA_MAPPING_PREVIEW_REQUEST,
    INSIGHT_AREA_MAPPING_PREVIEW_RESPONSE,
    INSIGHT_AREA_REMOVE_MAPPING,
    INSIGHT_AREA_REMOVE_OWNER_VIEWER,
    INSIGHT_AREA_REMOVE_PLACEHOLDER,
    INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS,
    INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE,
    INSIGHT_AREA_SELECT_ADD_OWNER_VIEWER,
    INSIGHT_AREA_SELECT_PERMISSION_HOLDER_TYPE,
    INSIGHT_AREA_SET_EDIT_MODE,
    INSIGHT_AREA_SET_FILTER,
    INSIGHT_AREA_UPDATE_FILTER_CRITERIA,
    INSIGHT_AREA_UPDATE_IMAGE,
    INSIGHT_AREA_UPDATE_MODEL,
    INSIGHT_AREA_UPDATE_PLACEHOLDER_ATTRIBUTION,
    INSIGHT_AREA_FINGERPRINT_PREVIEW_REQUEST,
    INSIGHT_AREA_FINGERPRINT_PREVIEW_RESPONSE,
    INSIGHT_AREA_FINGERPRINT_PREVIEW_ERROR_RESPONSE,
    INSIGHT_AREA_FINGERPRINT_REMOVE_CONCEPT,
} from "./action-types"
import {
    addPlaceholderImages,
    updatePlaceholder,
} from "./default-actions/placeholder-actions"
import {
    itemRequest,
    itemResponse,
    listPageRequest,
    listSearchRequest,
    listResponse,
    setFilter,
    setEditMode,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateImage,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    defaultAction,
} from "./default-actions/presentation-actions"
import {
    selectPermissionHolderType,
    removeOwnerViewer,
    searchAddOwnersViewers,
    searchAddOwnersViewersResponse,
    selectAddOwnerViewer,
} from "./default-actions/owner-viewer-actions"
import {
    removeMapping,
    mappingPreviewRequest,
    mappingPreviewResponse,
    mappingPreviewErrorResponse,
} from "./default-actions/mapping-actions"

export const insightAreaItemRequest = itemRequest(INSIGHT_AREA_ITEM_REQUEST)
export const insightAreaItemResponse = itemResponse(INSIGHT_AREA_ITEM_RESPONSE)
export const insightAreaItemSyncRequest = itemRequest(
    INSIGHT_AREA_ITEM_SYNC_REQUEST
)
export const insightAreaItemSyncResponse = itemResponse(
    INSIGHT_AREA_ITEM_SYNC_RESPONSE
)
export const insightAreaItemSaveResponse = itemResponse(
    INSIGHT_AREA_ITEM_SAVE_RESPONSE
)
const insightAreaListResponse = listResponse(INSIGHT_AREA_LIST_RESPONSE)
export const insightAreaListPageRequest = listPageRequest(
    INSIGHT_AREA_LIST_PAGE_REQUEST,
    insightAreaListResponse
)
export const insightAreaListSearchRequest = listSearchRequest(
    INSIGHT_AREA_LIST_SEARCH_REQUEST,
    insightAreaListResponse
)
export const insightAreaSetFilter = setFilter(INSIGHT_AREA_SET_FILTER)
export const insightAreaSetEditMode = setEditMode(INSIGHT_AREA_SET_EDIT_MODE)
export const insightAreaUpdateFilterCriteria = updateFilterCriteria(
    INSIGHT_AREA_UPDATE_FILTER_CRITERIA
)
export const insightAreaClearFilterCriteria = clearFilterCriteria(
    INSIGHT_AREA_CLEAR_FILTER_CRITERIA
)
export const insightAreaApplyFilterCriteria = applyFilterCriteria(
    INSIGHT_AREA_APPLY_FILTER_CRITERIA
)
export const insightAreaUpdateModel = updateModel(INSIGHT_AREA_UPDATE_MODEL)
export const insightAreaUpdateImage = updateImage(INSIGHT_AREA_UPDATE_IMAGE)
export const insightAreaApplyModelUpdate = applyModelUpdate(
    INSIGHT_AREA_APPLY_MODEL_UPDATE
)
export const insightAreaCancelModelUpdate = cancelModelUpdate(
    INSIGHT_AREA_CANCEL_MODEL_UPDATE
)
export const insightAreaAddNew = defaultAction(INSIGHT_AREA_ADD_NEW)
export const insightAreaFinishSaving = defaultAction(INSIGHT_AREA_FINISH_SAVING)
export const insightAreaFinishSavingError = defaultAction(
    INSIGHT_AREA_FINISH_SAVING_ERROR
)

export const insightAreaListInvalidationRequest = (pagingRequest) =>
    insightAreaListPageRequest({
        ...pagingRequest,
        isInvalidating: true,
        offset: 0,
        nextOffset: 0,
    })

// Placeholder actions
export const insightAreaAddPlaceholderImages = addPlaceholderImages(
    INSIGHT_AREA_ADD_PLACEHOLDER_IMAGES
)
export const insightAreaUpdatePlaceholderAttribution = updatePlaceholder(
    INSIGHT_AREA_UPDATE_PLACEHOLDER_ATTRIBUTION
)
export const insightAreaRemovePlaceholder = updatePlaceholder(
    INSIGHT_AREA_REMOVE_PLACEHOLDER
)

// Mapping actions
export const insightAreaAddMapping = (concept) => ({
    type: INSIGHT_AREA_ADD_MAPPING,
    concept,
})
export const insightAreaRemoveMapping = removeMapping(
    INSIGHT_AREA_REMOVE_MAPPING
)
export const insightAreaMappingPreviewRequest = mappingPreviewRequest(
    INSIGHT_AREA_MAPPING_PREVIEW_REQUEST
)
export const insightAreaMappingDeletePreviewRequest = mappingPreviewRequest(
    INSIGHT_AREA_MAPPING_DELETE_PREVIEW_REQUEST
)
export const insightAreaMappingPreviewResponse = mappingPreviewResponse(
    INSIGHT_AREA_MAPPING_PREVIEW_RESPONSE
)
export const insightAreaMappingPreviewErrorResponse = mappingPreviewErrorResponse(
    INSIGHT_AREA_MAPPING_PREVIEW_ERROR_RESPONSE
)

export const insightAreaFingerprintPreviewRequest = () => ({
    type: INSIGHT_AREA_FINGERPRINT_PREVIEW_REQUEST,
})
export const insightAreaFingerprintPreviewResponse = mappingPreviewResponse(
    INSIGHT_AREA_FINGERPRINT_PREVIEW_RESPONSE
)
export const insightAreaFingerprintPreviewErrorResponse = mappingPreviewErrorResponse(
    INSIGHT_AREA_FINGERPRINT_PREVIEW_ERROR_RESPONSE
)
export const insightAreaFingerprintRemoveConcept = (removedConcept) => ({
    type: INSIGHT_AREA_FINGERPRINT_REMOVE_CONCEPT,
    data: removedConcept,
})

// Owner/Viewer actions
export const insightAreaSelectPermissionHolderType = selectPermissionHolderType(
    INSIGHT_AREA_SELECT_PERMISSION_HOLDER_TYPE
)
export const insightAreaRemoveOwnerViewer = removeOwnerViewer(
    INSIGHT_AREA_REMOVE_OWNER_VIEWER
)
export const insightAreaSearchAddOwnersViewers = searchAddOwnersViewers(
    INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS
)
export const insightAreaSearchAddOwnersViewersResponse = searchAddOwnersViewersResponse(
    INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE
)
export const insightAreaSelectAddOwnerViewer = selectAddOwnerViewer(
    INSIGHT_AREA_SELECT_ADD_OWNER_VIEWER
)
export const insightAreaApplyAddOwnersViewers = defaultAction(
    INSIGHT_AREA_APPLY_ADD_OWNERS_VIEWERS
)
export const insightAreaCancelAddOwnersViewers = defaultAction(
    INSIGHT_AREA_CANCEL_ADD_OWNERS_VIEWERS
)
